var _path, _path2, _g, _path3, _g2, _g3, _g4, _g5, _g6, _g7, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPersonalBranding = function SvgPersonalBranding(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 217,
    viewBox: "0 0 224 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 427318768"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Left-5",
    d: "M35.8899 181.32L51.7472 175.065C52.1473 174.905 52.2541 174.212 51.974 173.518L43.5852 152.246C43.3184 151.552 42.7716 151.126 42.3582 151.272L26.5009 157.527C25.914 157.754 26.0207 159.048 26.6876 159.741L34.1028 167.423C34.4495 167.783 34.6896 168.37 34.6762 168.877L34.5029 179.546C34.4895 180.506 35.2898 181.533 35.8766 181.293L35.8899 181.32Z",
    fill: "#4539FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Left-6",
    d: "M187.409 181.36L171.631 174.892C171.231 174.732 171.138 174.038 171.418 173.345L180.1 152.193C180.38 151.499 180.94 151.072 181.34 151.246L197.118 157.714C197.704 157.954 197.571 159.248 196.891 159.928L189.369 167.503C189.009 167.863 188.769 168.45 188.769 168.957L188.796 179.626C188.796 180.587 187.982 181.6 187.395 181.36H187.409Z",
    fill: "#4539FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_1241_128649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.401 26.4806L29.475 80.9078C24.9138 84.2153 23.0067 90.0968 24.7538 95.4582L53.3744 183.534C55.1215 188.895 60.1094 192.523 65.7509 192.523H158.361C164.003 192.523 168.991 188.895 170.738 183.534L199.358 95.4582C201.105 90.0968 199.198 84.2287 194.637 80.9078L119.711 26.4806C115.15 23.1731 108.975 23.1731 104.414 26.4806H104.401Z",
    fill: "url(#paint0_linear_1241_128649)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M106.028 30.735L32.7158 84.0019C29.2616 86.5092 27.8212 90.9637 29.1416 95.0181L57.1487 181.2C58.4691 185.254 62.2567 188.015 66.5244 188.015H157.134C161.402 188.015 165.19 185.268 166.51 181.2L194.517 95.0181C195.837 90.9637 194.397 86.5092 190.943 84.0019L117.631 30.735C114.177 28.2277 109.495 28.2277 106.041 30.735H106.028Z",
    fill: "url(#paint1_linear_1241_128649)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Base-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1241_128649",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 28,
    width: 168,
    height: 161
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M106.254 30.735L32.9425 84.0019C29.4883 86.5092 28.0479 90.9637 29.3683 95.0181L57.3754 181.2C58.6957 185.254 62.4833 188.015 66.7511 188.015H157.361C161.629 188.015 165.416 185.268 166.737 181.2L194.744 95.0181C196.064 90.9637 194.624 86.5092 191.169 84.0019L117.857 30.735C114.403 28.2277 109.722 28.2277 106.268 30.735H106.254Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1241_128649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M112.123 228.412C166.931 228.412 211.361 202.157 211.361 169.77C211.361 137.384 166.931 111.129 112.123 111.129C57.3147 111.129 12.884 137.384 12.884 169.77C12.884 202.157 57.3147 228.412 112.123 228.412Z",
    fill: "#30AFD3"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Shine-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1241_128649",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 24,
    width: 176,
    height: 169
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M104.401 26.4806L29.475 80.9078C24.9138 84.2153 23.0067 90.0968 24.7538 95.4582L53.3744 183.534C55.1215 188.895 60.1094 192.523 65.7509 192.523H158.361C164.003 192.523 168.991 188.895 170.738 183.534L199.358 95.4582C201.105 90.0968 199.198 84.2287 194.637 80.9078L119.711 26.4806C115.15 23.1731 108.975 23.1731 104.414 26.4806H104.401Z",
    fill: "white"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1241_128649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.15,
    d: "M4.96215 239.762C2.36148 232.506 1.05452 228.412 -1.54614 219.263C15.885 206.326 34.6097 197.577 53.1478 186.561C72.7528 174.918 88.6635 159.701 105.975 144.991C141.81 114.57 168.19 109.208 213.509 121.385C216.109 123.719 217.416 124.919 220.017 127.52C173.818 113.876 147.759 124.706 112.483 155.714C78.1408 185.921 37.3037 207.873 4.94884 239.748L4.96215 239.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.15,
    d: "M-5.05374 223.597C-20.8978 195.51 -27.9396 162.409 -35.3281 131.427C12.0706 132.188 37.3837 108.421 72.2059 79.3741C107.748 49.7265 135.449 41.8712 179.74 56.5683C190.223 66.9843 200.279 77.2269 210.014 88.3497C163.949 66.4775 133.928 96.4184 102.48 128.573C68.4583 163.369 30.3286 190.722 -5.05374 223.597Z",
    fill: "white"
  })))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Stars-3",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M118.711 42.6714C119.322 42.6714 119.818 42.1758 119.818 41.5645C119.818 40.9531 119.322 40.4575 118.711 40.4575C118.1 40.4575 117.604 40.9531 117.604 41.5645C117.604 42.1758 118.1 42.6714 118.711 42.6714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M131.488 51.8338C132.836 51.8338 133.928 50.7411 133.928 49.3931C133.928 48.0452 132.836 46.9525 131.488 46.9525C130.14 46.9525 129.047 48.0452 129.047 49.3931C129.047 50.7411 130.14 51.8338 131.488 51.8338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M119.818 50.34C121.114 50.34 122.165 49.2891 122.165 47.9928C122.165 46.6964 121.114 45.6455 119.818 45.6455C118.522 45.6455 117.471 46.6964 117.471 47.9928C117.471 49.2891 118.522 50.34 119.818 50.34Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M55.1215 142.39C56.0349 142.39 56.7753 141.65 56.7753 140.736C56.7753 139.823 56.0349 139.083 55.1215 139.083C54.2082 139.083 53.4678 139.823 53.4678 140.736C53.4678 141.65 54.2082 142.39 55.1215 142.39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M55.9485 132.921C57.2964 132.921 58.3891 131.828 58.3891 130.48C58.3891 129.133 57.2964 128.04 55.9485 128.04C54.6005 128.04 53.5078 129.133 53.5078 130.48C53.5078 131.828 54.6005 132.921 55.9485 132.921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M64.564 144.191C65.1754 144.191 65.6709 143.695 65.6709 143.084C65.6709 142.472 65.1754 141.977 64.564 141.977C63.9527 141.977 63.457 142.472 63.457 143.084C63.457 143.695 63.9527 144.191 64.564 144.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M173.472 146.324L171.471 149.605C171.164 150.112 170.418 150.112 170.097 149.605L168.097 146.324C167.937 146.071 167.937 145.751 168.097 145.484L170.097 142.203C170.404 141.697 171.151 141.697 171.471 142.203L173.472 145.484C173.632 145.738 173.632 146.071 173.472 146.324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M166.79 138.669L165.976 139.99C165.856 140.203 165.55 140.203 165.416 139.99L164.603 138.669C164.536 138.563 164.536 138.429 164.603 138.336L165.416 137.015C165.536 136.802 165.843 136.802 165.976 137.015L166.79 138.336C166.857 138.442 166.857 138.576 166.79 138.669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M49.2667 86.976L48.0931 88.8832C47.9064 89.1766 47.4796 89.1766 47.2929 88.8832L46.1326 86.976C46.0393 86.8293 46.0393 86.6426 46.1326 86.4826L47.2929 84.5754C47.4796 84.282 47.9064 84.282 48.0931 84.5754L49.2667 86.4826C49.3601 86.6293 49.3601 86.816 49.2667 86.976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M59.0026 93.0042L56.7354 96.7118C56.3753 97.2853 55.5351 97.2853 55.1883 96.7118L52.921 93.0042C52.7477 92.7108 52.7477 92.3507 52.921 92.0573L55.1883 88.3497C55.5484 87.7762 56.3887 87.7762 56.7354 88.3497L59.0026 92.0573C59.176 92.3507 59.176 92.7108 59.0026 93.0042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M171.805 133.228L170.364 135.575C170.137 135.948 169.604 135.948 169.377 135.575L167.937 133.228C167.83 133.041 167.83 132.814 167.937 132.628L169.377 130.28C169.604 129.907 170.137 129.907 170.364 130.28L171.805 132.628C171.911 132.814 171.911 133.041 171.805 133.228Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    filter: "url(#filter1_d_1241_128649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M148.479 60.8094H77.5938C75.9145 60.8094 74.5531 62.1708 74.5531 63.8501V152.993C74.5531 154.672 75.9145 156.034 77.5938 156.034H148.479C150.158 156.034 151.519 154.672 151.519 152.993V63.8501C151.519 62.1708 150.158 60.8094 148.479 60.8094Z",
    fill: "url(#paint2_linear_1241_128649)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M139.45 71.9455H86.6228C83.2567 71.9455 80.528 74.6743 80.528 78.0404V144.617C80.528 147.983 83.2567 150.712 86.6228 150.712H139.45C142.816 150.712 145.545 147.983 145.545 144.617V78.0404C145.545 74.6743 142.816 71.9455 139.45 71.9455Z",
    fill: "white",
    stroke: "#FDB35E",
    strokeWidth: 2.57399,
    strokeMiterlimit: 10
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M133.942 89.0565H91.3707V131.627H133.942V89.0565Z",
    stroke: "#582B34",
    strokeWidth: 0.360092,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M118.231 115.183H106.721L104.708 119.878C104.214 121.038 103.961 121.892 103.961 122.465C103.961 122.918 104.174 123.319 104.614 123.665C105.041 124.012 105.975 124.225 107.415 124.332V125.146H98.0525V124.332C99.2928 124.119 100.106 123.825 100.466 123.479C101.213 122.772 102.04 121.345 102.947 119.198L113.403 94.7246H114.177L124.526 119.464C125.353 121.451 126.113 122.745 126.793 123.332C127.473 123.919 128.42 124.252 129.634 124.332V125.146H117.898V124.332C119.085 124.279 119.885 124.079 120.298 123.745C120.712 123.412 120.925 122.999 120.925 122.518C120.925 121.878 120.632 120.865 120.045 119.464L118.244 115.183H118.231ZM117.617 113.556L112.576 101.54L107.402 113.556H117.617Z",
    fill: "#582B34"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M113.683 87.9629H111.403V90.2435H113.683V87.9629Z",
    fill: "#582B34"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M135.075 87.9629H132.795V90.2435H135.075V87.9629Z",
    fill: "#582B34"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M92.5043 87.9096H90.2238V90.1902H92.5043V87.9096Z",
    fill: "#582B34"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M92.5043 130.48H90.2238V132.761H92.5043V130.48Z",
    fill: "#582B34"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M135.075 130.48H132.795V132.761H135.075V130.48Z",
    fill: "#582B34"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M113.683 130.48H111.403V132.761H113.683V130.48Z",
    fill: "#582B34"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M135.075 109.195H132.795V111.476H135.075V109.195Z",
    fill: "#582B34"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M92.5043 109.195H90.2238V111.476H92.5043V109.195Z",
    fill: "#582B34"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M141.664 68.7314C142.938 68.7314 143.971 67.6984 143.971 66.4241C143.971 65.1498 142.938 64.1169 141.664 64.1169C140.389 64.1169 139.356 65.1498 139.356 66.4241C139.356 67.6984 140.389 68.7314 141.664 68.7314Z",
    fill: "#FF1D25"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M135.089 68.7314C136.363 68.7314 137.396 67.6984 137.396 66.4241C137.396 65.1498 136.363 64.1169 135.089 64.1169C133.814 64.1169 132.781 65.1498 132.781 66.4241C132.781 67.6984 133.814 68.7314 135.089 68.7314Z",
    fill: "#FDF0B3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M171.871 184.654C131.088 170.971 94.7184 171.131 54.0547 185.161C51.8408 186.068 49.4668 185.494 48.72 183.827C45.5992 176.732 44.0387 173.171 40.9179 166.076C40.1844 164.396 41.6648 162.128 44.2388 161.075C90.5972 144.497 134.155 144.191 180.767 160.128C183.368 161.142 184.861 163.409 184.154 165.089C181.394 172.384 180.007 176.012 177.193 183.281C176.472 184.961 174.099 185.548 171.871 184.668V184.654Z",
    fill: "#4539FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M55.0948 170.464C55.0148 170.891 54.8147 171.277 54.4947 171.611C54.1746 171.958 53.7212 172.224 53.1344 172.398L52.0541 172.731L52.8943 175.465L51.1605 175.999L48.7999 168.397L51.614 167.53C52.1874 167.356 52.6943 167.303 53.1477 167.396C53.6012 167.49 53.9879 167.677 54.2947 167.983C54.6014 168.29 54.8281 168.677 54.9882 169.157C55.1216 169.597 55.1482 170.024 55.0815 170.451L55.0948 170.464ZM53.2144 170.491C53.3211 170.277 53.3344 170.01 53.241 169.717C53.1476 169.41 52.9876 169.21 52.7742 169.09C52.5609 168.97 52.2808 168.97 51.9607 169.077L51.0138 169.37L51.6006 171.277L52.5475 170.984C52.881 170.877 53.0943 170.717 53.2144 170.504V170.491Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M58.2824 167.236L58.6958 168.797L61.0431 168.17L61.4298 169.61L59.0825 170.237L59.536 171.918L62.19 171.211L62.5901 172.705L58.1757 173.878L56.1218 166.196L60.5363 165.009L60.9364 166.503L58.2824 167.21V167.236Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M68.0981 171.397L65.9109 168.823L65.4842 168.917L66.1643 171.838L64.3906 172.251L62.6034 164.502L65.5775 163.822C66.1509 163.689 66.6578 163.689 67.1112 163.809C67.5647 163.929 67.9381 164.156 68.2182 164.476C68.4983 164.796 68.6983 165.196 68.805 165.649C68.925 166.169 68.8984 166.65 68.7116 167.13C68.5383 167.597 68.1915 167.983 67.7114 168.277L70.0986 170.957L68.0981 171.424V171.397ZM65.1774 167.583L66.271 167.33C66.5911 167.25 66.8178 167.116 66.9378 166.903C67.0579 166.69 67.0845 166.436 67.0178 166.129C66.9512 165.836 66.8178 165.623 66.6178 165.489C66.4177 165.356 66.1509 165.329 65.8309 165.409L64.7373 165.663L65.1774 167.583Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M73.0194 170.13C72.5526 170.024 72.1658 169.824 71.8457 169.504C71.5257 169.184 71.2989 168.783 71.1923 168.263L73.086 167.89C73.1661 168.17 73.3128 168.37 73.4995 168.503C73.6862 168.623 73.9129 168.663 74.1663 168.61C74.4331 168.557 74.6198 168.45 74.7531 168.29C74.8865 168.13 74.9266 167.93 74.8732 167.703C74.8332 167.516 74.7398 167.37 74.5931 167.263C74.4464 167.156 74.273 167.09 74.0863 167.036C73.8996 166.983 73.6195 166.943 73.2728 166.903C72.766 166.836 72.3525 166.756 72.0191 166.663C71.6857 166.57 71.3923 166.383 71.1122 166.129C70.8322 165.876 70.6588 165.489 70.5521 164.996C70.4054 164.276 70.5521 163.649 70.9522 163.142C71.3656 162.635 71.9658 162.302 72.766 162.142C73.5662 161.982 74.2597 162.062 74.8332 162.382C75.4066 162.702 75.7801 163.222 75.9668 163.942L74.033 164.316C73.9663 164.062 73.8463 163.889 73.6596 163.769C73.4729 163.649 73.2461 163.622 73.006 163.676C72.7926 163.716 72.6326 163.809 72.5259 163.956C72.4192 164.102 72.3926 164.289 72.4326 164.516C72.4859 164.769 72.6326 164.943 72.886 165.036C73.1394 165.129 73.5128 165.223 74.0196 165.289C74.5264 165.369 74.9399 165.449 75.2733 165.556C75.5934 165.649 75.9001 165.836 76.1668 166.089C76.4469 166.343 76.6203 166.703 76.7137 167.17C76.7937 167.61 76.767 168.037 76.6337 168.45C76.487 168.85 76.2469 169.21 75.8735 169.504C75.5134 169.797 75.0599 169.997 74.5131 170.104C73.9796 170.211 73.4862 170.211 73.0194 170.104V170.13Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M80.4479 168.53C79.8211 168.277 79.2876 167.863 78.8475 167.303C78.4074 166.743 78.1273 166.076 78.0073 165.303C77.8873 164.529 77.954 163.822 78.194 163.155C78.4341 162.489 78.8208 161.942 79.341 161.502C79.8611 161.062 80.4746 160.795 81.1681 160.688C81.8616 160.581 82.5285 160.648 83.1553 160.902C83.7822 161.155 84.3156 161.555 84.7424 162.115C85.1692 162.675 85.4492 163.342 85.5693 164.116C85.6893 164.889 85.636 165.609 85.3959 166.276C85.1558 166.943 84.7824 167.503 84.2622 167.93C83.7421 168.357 83.142 168.637 82.4484 168.744C81.7549 168.85 81.0881 168.784 80.4613 168.53H80.4479ZM83.4754 166.156C83.7688 165.689 83.8488 165.103 83.7422 164.422C83.6355 163.729 83.3687 163.195 82.9552 162.849C82.5418 162.489 82.035 162.355 81.4482 162.449C80.848 162.542 80.4079 162.822 80.1279 163.289C79.8345 163.756 79.7544 164.342 79.8611 165.036C79.9678 165.729 80.2346 166.263 80.648 166.61C81.0615 166.97 81.5682 167.103 82.1683 167.01C82.7552 166.916 83.1953 166.636 83.4754 166.156Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M94.5049 167.09L92.7044 167.303L89.1168 162.782L89.677 167.663L87.8765 167.877L86.9563 159.968L88.7567 159.755L92.3443 164.302L91.7708 159.408L93.5713 159.194L94.4916 167.103L94.5049 167.09Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M101.013 165.143L98.2391 165.356L97.9057 166.796L96.0118 166.943L98.1057 158.808L100.2 158.648L103.494 166.383L101.573 166.53L101.026 165.156L101.013 165.143ZM100.44 163.689L99.2927 160.848L98.5992 163.822L100.426 163.689H100.44Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M106.775 164.729L109.149 164.636L109.215 166.13L105.028 166.303L104.694 158.354L106.508 158.274L106.775 164.729Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M119.365 162.675C119.631 163.035 119.751 163.449 119.751 163.902C119.751 164.569 119.525 165.089 119.085 165.476C118.644 165.863 118.044 166.049 117.257 166.049L113.79 166.023L113.843 158.061H117.204C117.964 158.087 118.551 158.274 118.978 158.648C119.405 159.021 119.618 159.528 119.618 160.155C119.618 160.621 119.498 161.008 119.271 161.315C119.044 161.622 118.724 161.835 118.351 161.955C118.778 162.062 119.125 162.289 119.391 162.649L119.365 162.675ZM117.657 164.276C117.818 164.129 117.911 163.916 117.911 163.636C117.911 163.355 117.831 163.142 117.657 162.982C117.484 162.822 117.244 162.742 116.937 162.742H115.617V164.489H116.951C117.257 164.489 117.497 164.422 117.657 164.276ZM115.63 161.315H116.817C117.111 161.315 117.337 161.262 117.497 161.115C117.657 160.982 117.737 160.768 117.737 160.501C117.737 160.235 117.657 160.021 117.497 159.875C117.337 159.728 117.111 159.661 116.817 159.648H115.63V161.302V161.315Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M125.273 166.29L123.859 163.222H123.419L123.286 166.21L121.472 166.129L121.832 158.181L124.873 158.314C125.459 158.341 125.953 158.474 126.353 158.714C126.753 158.954 127.06 159.261 127.247 159.661C127.433 160.048 127.513 160.475 127.5 160.955C127.473 161.488 127.313 161.955 127.02 162.355C126.726 162.755 126.3 163.035 125.74 163.182L127.313 166.41L125.259 166.316L125.273 166.29ZM123.486 161.835L124.606 161.888C124.939 161.902 125.193 161.822 125.366 161.662C125.539 161.502 125.633 161.248 125.646 160.941C125.66 160.635 125.593 160.395 125.433 160.221C125.273 160.035 125.033 159.941 124.699 159.928L123.579 159.875L123.486 161.848V161.835Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M133.808 165.503L131.034 165.263L130.474 166.623L128.58 166.463L131.968 158.768L134.062 158.954L136.062 167.116L134.142 166.943L133.822 165.503H133.808ZM133.475 163.969L132.808 160.982L131.648 163.809L133.475 163.969Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M144.144 168.17L142.344 167.93L139.996 162.662L139.343 167.53L137.542 167.29L138.609 159.408L140.41 159.648L142.757 164.943L143.424 160.061L145.224 160.301L144.158 168.183L144.144 168.17Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M152.24 162.035C152.76 162.475 153.12 163.009 153.32 163.662C153.533 164.316 153.56 165.023 153.413 165.796C153.266 166.556 152.986 167.21 152.56 167.743C152.133 168.277 151.599 168.663 150.959 168.877C150.319 169.104 149.612 169.13 148.852 168.997L146.105 168.49L147.558 160.661L150.306 161.168C151.079 161.315 151.719 161.595 152.24 162.035ZM150.733 167.023C151.186 166.703 151.466 166.183 151.599 165.449C151.733 164.729 151.653 164.129 151.346 163.662C151.039 163.195 150.559 162.889 149.879 162.769L149.039 162.609L148.198 167.156L149.039 167.316C149.719 167.437 150.279 167.343 150.719 167.023H150.733Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M157.868 162.729L156.134 170.491L154.36 170.09L156.094 162.328L157.868 162.729Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M164.576 172.611L162.816 172.144L161.122 166.623L159.882 171.371L158.121 170.904L160.148 163.209L161.909 163.676L163.589 169.21L164.843 164.436L166.603 164.903L164.576 172.598V172.611Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M172.845 169.504C172.791 169.21 172.671 168.957 172.485 168.743C172.298 168.53 172.031 168.37 171.711 168.277C171.151 168.103 170.644 168.157 170.177 168.437C169.711 168.717 169.377 169.184 169.164 169.85C168.937 170.544 168.937 171.144 169.164 171.651C169.391 172.158 169.817 172.504 170.431 172.704C170.858 172.838 171.258 172.838 171.618 172.704C171.991 172.571 172.311 172.304 172.578 171.918L170.377 171.211L170.818 169.85L174.579 171.064L174.032 172.785C173.752 173.198 173.405 173.558 172.965 173.865C172.525 174.158 172.045 174.358 171.484 174.452C170.938 174.545 170.364 174.492 169.764 174.305C169.057 174.078 168.484 173.718 168.044 173.211C167.603 172.704 167.323 172.118 167.203 171.438C167.083 170.757 167.15 170.037 167.39 169.29C167.63 168.543 168.004 167.93 168.497 167.436C168.991 166.943 169.564 166.623 170.217 166.476C170.871 166.33 171.551 166.356 172.245 166.583C173.098 166.85 173.738 167.303 174.179 167.93C174.619 168.557 174.805 169.29 174.752 170.131L172.845 169.517V169.504Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1241_128649",
    x: 0.106806,
    y: -0.00610924,
    width: 223.898,
    height: 216.535,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.0031
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_128649"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_128649",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1241_128649",
    x: 74.5531,
    y: 60.8094,
    width: 80.1803,
    height: 98.4384,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.21415,
    dy: 3.21415
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_128649"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_128649",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1241_128649",
    x1: 112.403,
    y1: -12.9027,
    x2: 112.069,
    y2: 101.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#25B2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D6F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1241_128649",
    x1: 111.229,
    y1: -32.8812,
    x2: 112.029,
    y2: 133.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6B72FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#4495F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#26B1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#11C5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#04D1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D6F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1241_128649",
    x1: 74.5531,
    y1: 108.421,
    x2: 151.519,
    y2: 108.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F28E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FDB35E"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPersonalBranding);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "personal-branding.7faa704.svg";